(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		// $(document).ready is a jQuery event that
		// gets called as soon as the DOM is ready

		
	});




/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {
		// $(window).on('load') executes when the page
		// is fully loaded, including all objects and
		// images
		
	});


})(jQuery);
